import { useEffect, useState } from "react";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import {
  GetScheduledUpcomingInterviewsListPayloadType,
  SingleScheduledUpcomingInterviewsDeatilsPayloadType,
} from "../../../commonTypes/thinksToDoTypes";
import {
  getScheduledUpcomingInterviewsList,
  resetScheduledUpcomingInterviewsList,
  resetThinksToDoError,
  resetThinksToDoMessage,
  resetThinksToDoStatusCode,
  resetThinksToDoSuccess,
  singleScheduledUpcomingInterviewsDetailsAction,
  updateRecruitmentTrackerAction,
} from "../../../redux/thinksToDo";
import {
  AddScheduledUpcomingInterviewsDetailsType,
  ScheduledUpcomingInterviewsListType,
  SingleScheduledUpcomingInterviewsDetailsType,
} from "../../../redux/thinksToDo/thinksToDoType";
import AllInterviewTableList from "../AllInterviewTableList/AllInterviewTableList";
import FeedBackModal from "../FeedBackModal";
import { ErrorSuccessModal, Loader } from "../../commons";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import { resetSession } from "../../../redux/auth";
import { formatDate } from "../../../utils/commonFunctions";
import toast from "react-hot-toast";
import { resetHrmsError } from "../../../redux/hrms";
type AppProps = {
  history: any;
  dispatchGetScheduledUpcomingInterviewsList: (
    data: GetScheduledUpcomingInterviewsListPayloadType
  ) => void;
  token: string | null;
  scheduledUpcomingInterviewsList: ScheduledUpcomingInterviewsListType[] | [];
  fetching: boolean;
  singleScheduledUpcomingInterviewsDetails: SingleScheduledUpcomingInterviewsDetailsType;
  totalCount: number;
  dispatchSingleScheduledUpcomingInterviewsDetails: (
    data: SingleScheduledUpcomingInterviewsDeatilsPayloadType
  ) => void;
  loginData: LoginResponseType;

  statusCode: number | null;
  success: number | null;
  error: string | null;
  message: string | null;

  hrmsStatusCode: number | null;
  hrmsSuccess: number | null;
  hrmsError: string | null;
  // hrmsMessage: string | null;
  dispatchResetSession: () => void;
  dispatchResetThinksToDoError: () => void;
  dispatchResetThinksToDoMessage: () => void;
  dispatchResetThinksToDoStatusCode: () => void;
  dispatchResetThinksToDoSuccess: () => void;
  dispatchResetScheduledUpcomingInterviewsList: () => void;
  dispatchUpdateRecruitmentTrackerListAction: (
    data: AddScheduledUpcomingInterviewsDetailsType
  ) => void;
  updateFetching: boolean;
  dispatchResetHrmsError: () => void;
};

const AllInterviewList = ({
  history,
  dispatchGetScheduledUpcomingInterviewsList,
  token,
  scheduledUpcomingInterviewsList,
  fetching,
  singleScheduledUpcomingInterviewsDetails,
  totalCount,
  dispatchSingleScheduledUpcomingInterviewsDetails,
  loginData,
  hrmsStatusCode,
  hrmsSuccess,
  hrmsError,
  // hrmsMessage,
  statusCode,
  success,
  error,
  message,
  dispatchResetSession,
  dispatchResetThinksToDoError,
  dispatchResetThinksToDoMessage,
  dispatchResetThinksToDoStatusCode,
  dispatchResetThinksToDoSuccess,
  dispatchResetScheduledUpcomingInterviewsList,
  dispatchUpdateRecruitmentTrackerListAction,
  updateFetching,
  dispatchResetHrmsError,
}: AppProps) => {
  const [feedbackModal, setFeedbackModal] = useState(false);
  const [singleId, setSingleId] = useState("");
  const [singleScheduledDetails, setSingleScheduledDetails] = useState<any>({});
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [data, setData] = useState<[] | ScheduledUpcomingInterviewsListType[]>(
    []
  );
  useEffect(() => {
    dispatchResetThinksToDoError();
    dispatchResetThinksToDoMessage();
    dispatchResetThinksToDoStatusCode();
    dispatchResetThinksToDoSuccess();
    dispatchResetScheduledUpcomingInterviewsList();
    dispatchResetHrmsError();
  }, []);

  useEffect(() => {
    if (token) {
      const finalData = {
        token,
        limit,
        offset,
      };

      if (totalCount) {
        if (offset < +totalCount) {
          dispatchGetScheduledUpcomingInterviewsList(finalData);
        }
      } else {
        dispatchGetScheduledUpcomingInterviewsList(finalData);
      }
    }
  }, [offset]);

  useEffect(() => {
    if (feedbackModal && token) {
      let finalData = {
        token,
        id: singleId,
        type: "things_to_do",
      };
      dispatchSingleScheduledUpcomingInterviewsDetails(finalData);
    }
  }, [feedbackModal]);

  const handleFeedBackModal = (data?: string) => {
    setFeedbackModal(!feedbackModal);
    if (data) {
      setSingleId(data);
    } else {
      setSingleId("");
    }
  };
  useEffect(() => {
    if (scheduledUpcomingInterviewsList?.length === 0) {
      setData(scheduledUpcomingInterviewsList);
    } else if (
      offset > 0 &&
      scheduledUpcomingInterviewsList?.length > 0 &&
      !fetching
    ) {
      setData((prv: any) => [...prv, ...scheduledUpcomingInterviewsList]);
    } else {
      setData(scheduledUpcomingInterviewsList);
    }
  }, [scheduledUpcomingInterviewsList]);
  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      if (
        offset < +totalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (scheduledUpcomingInterviewsList?.length > 0) {
          if (!fetching && offset < +totalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    if (
      singleScheduledUpcomingInterviewsDetails &&
      Object.keys(singleScheduledUpcomingInterviewsDetails)
    ) {
      setSingleScheduledDetails({
        ...singleScheduledUpcomingInterviewsDetails,
      });
    }
  }, [singleScheduledUpcomingInterviewsDetails]);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scheduledUpcomingInterviewsList]);

  const handleErrorModal = () => {
    if (success === 0 || hrmsSuccess === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (hrmsStatusCode === 0) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!hrmsError}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={hrmsStatusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetThinksToDoError();
            }}
          />
        );
      } else if (!!hrmsError && hrmsStatusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!hrmsError}
            title="Error"
            message={hrmsError}
            buttonText="OK"
            onPress={() => {
              dispatchResetThinksToDoError();
            }}
          />
        );
      }
    } else if (
      message === "Recruitment details has been updated successfully."
    ) {
      toast.success("Feedback have been added successfuly", {
        duration: 2000,
      });

      dispatchResetThinksToDoError();
      dispatchResetThinksToDoMessage();
      dispatchResetThinksToDoStatusCode();
      dispatchResetThinksToDoSuccess();
      dispatchResetScheduledUpcomingInterviewsList();
      if (token) {
        const finalData = {
          token,
          limit,
          offset,
        };

        if (offset === 0) {
          dispatchGetScheduledUpcomingInterviewsList(finalData);
        } else {
          setOffset(0);
        }
      }
    }

    return false;
  };

  const handleSubmitFeedback = () => {
    if (token) {
      let interviewDetailsRounds =
        singleScheduledDetails?.interview_details?.interview_round_details?.map(
          (el: any) => {
            return {
              ...el,
              interviewer: el.interviewer?.user_id,
            };
          }
        );
      const finalData = {
        token,
        finalData: {
          ...singleScheduledUpcomingInterviewsDetails,
          id: singleScheduledUpcomingInterviewsDetails?._id,
          applicant_details: {
            ...singleScheduledUpcomingInterviewsDetails?.applicant_details,
            qualification:
              singleScheduledUpcomingInterviewsDetails?.applicant_details?.qualification?.map(
                (data: any) => data?._id
              ),
            skill:
              singleScheduledUpcomingInterviewsDetails?.applicant_details?.skill?.map(
                (data: any) => data?._id
              ),
          },
          position_details: {
            ...singleScheduledUpcomingInterviewsDetails?.position_details,
            offered_job_position:
              singleScheduledUpcomingInterviewsDetails?.position_details
                ?.offered_job_position?.id,
            department:
              singleScheduledUpcomingInterviewsDetails?.position_details
                ?.department?.id,
            job_position:
              singleScheduledUpcomingInterviewsDetails?.position_details?.job_position?.id.toString(),
            job_location:
              singleScheduledUpcomingInterviewsDetails?.position_details
                ?.job_location?.id,
            recruiter:
              singleScheduledUpcomingInterviewsDetails?.position_details
                ?.recruiter?.user_id,
            proposed_joining_date: singleScheduledUpcomingInterviewsDetails
              ?.position_details?.proposed_joining_date
              ? formatDate(
                  singleScheduledUpcomingInterviewsDetails?.position_details
                    ?.proposed_joining_date
                )
              : null,
          },
          interview_details: {
            ...singleScheduledUpcomingInterviewsDetails?.interview_details,
            application_date: formatDate(
              singleScheduledUpcomingInterviewsDetails?.interview_details
                ?.application_date
            ),
            screening_details: {
              ...singleScheduledUpcomingInterviewsDetails?.interview_details
                ?.screening_details,
              phone_screener:
                singleScheduledUpcomingInterviewsDetails?.interview_details
                  ?.screening_details?.phone_screener?.user_id,
            },
            interview_round_details: [...interviewDetailsRounds],
          },
          other_details: {
            ...singleScheduledUpcomingInterviewsDetails?.other_details,
            referred_by:
              singleScheduledUpcomingInterviewsDetails?.other_details
                ?.referred_by?.user_id,
          },
        },
      };
      dispatchUpdateRecruitmentTrackerListAction(finalData);
      handleFeedBackModal();
    }
  };

  const handleFeedBackAdded = (data: string) => {
    let updatedInterviewRoundDetails = [
      ...singleScheduledUpcomingInterviewsDetails?.interview_details
        ?.interview_round_details,
    ];

    let lastInterview =
      updatedInterviewRoundDetails[updatedInterviewRoundDetails.length - 1];

    let updatedLastInterview = {
      ...lastInterview,
      is_feedback_submited: true,
      interview_feedback: data,
    };

    updatedInterviewRoundDetails[updatedInterviewRoundDetails.length - 1] =
      updatedLastInterview;

    setSingleScheduledDetails({
      ...singleScheduledUpcomingInterviewsDetails,
      interview_details: {
        ...singleScheduledUpcomingInterviewsDetails?.interview_details,
        interview_round_details: updatedInterviewRoundDetails,
      },
    });
  };
  return (
    <>
      {/* <CommonHeader title={`Interview List`} /> */}
      <div className="new-table-card pt-4">
        <div className="row">
          <div className="col-md-12 d-flex justify-content-between">
            <div className="col-md-3 ml-3" style={{ padding: 0 }}>
              <div
                className="d-flex flex-column"
                style={{ justifyContent: "center", alignItems: "flex-start" }}
              >
                <h6 style={{ fontSize: "20px", fontWeight: 500 }}>
                  All Interview Feedbacks
                </h6>
                <div
                  style={{
                    color: "rgb(124, 141, 176)",
                    fontSize: "13px",
                    fontWeight: 500,
                  }}
                >
                  Total {totalCount} records found
                </div>
              </div>
            </div>
          </div>
        </div>
        <AllInterviewTableList
          data={data}
          fetching={fetching}
          handleFeedBackModal={handleFeedBackModal}
          offset={offset}
        />
      </div>

      {feedbackModal && (
        <FeedBackModal
          toggle={handleFeedBackModal}
          isOpen={feedbackModal}
          data={singleScheduledUpcomingInterviewsDetails}
          loginData={loginData}
          fetching={fetching}
          handleSubmitFeedback={handleSubmitFeedback}
          hanldeFeedback={handleFeedBackAdded}
          type={"finaccrm"}
        />
      )}
      {handleErrorModal()}
      {updateFetching && <Loader />}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  scheduledUpcomingInterviewsList: state.thinksToDo.scheduledUpcomingInterviews,
  fetching: state.thinksToDo.fetching,
  singleScheduledUpcomingInterviewsDetails:
    state.thinksToDo.singleScheduledUpcomingInterviewsDetails,
  totalCount: state.thinksToDo.totalCount,
  loginData: state.auth.loginData,
  error: state.thinksToDo.error,
  statusCode: state.thinksToDo.statusCode,
  success: state.thinksToDo.success,
  message: state.thinksToDo.message,
  updateFetching: state.thinksToDo.updateFetching,
  hrmsSuccess: state.hrms.success,
  hrmsStatusCode: state.hrms.statusCode,
  hrmsError: state.hrms.error,
  hrmsMessage: state.hrms.message,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetScheduledUpcomingInterviewsList: (
    data: GetScheduledUpcomingInterviewsListPayloadType
  ) => dispatch(getScheduledUpcomingInterviewsList(data)),
  dispatchSingleScheduledUpcomingInterviewsDetails: (
    data: SingleScheduledUpcomingInterviewsDeatilsPayloadType
  ) => dispatch(singleScheduledUpcomingInterviewsDetailsAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetThinksToDoError: () => dispatch(resetThinksToDoError()),
  dispatchResetThinksToDoMessage: () => dispatch(resetThinksToDoMessage()),
  dispatchResetThinksToDoStatusCode: () =>
    dispatch(resetThinksToDoStatusCode()),
  dispatchResetThinksToDoSuccess: () => dispatch(resetThinksToDoSuccess()),
  dispatchResetScheduledUpcomingInterviewsList: () =>
    dispatch(resetScheduledUpcomingInterviewsList()),
  dispatchUpdateRecruitmentTrackerListAction: (
    data: AddScheduledUpcomingInterviewsDetailsType
  ) => dispatch(updateRecruitmentTrackerAction(data)),
  dispatchResetHrmsError: () => dispatch(resetHrmsError()),
});
export default connect(mapStateToProps, mapDispatchToProps)(AllInterviewList);
